import { ReportsTranslate } from './reportsTranslate.model';

const reportsTranslateEN: ReportsTranslate = {
  page: {
    title: 'Reports and exports',
    subtitle:
      'Download CSV spreadsheets with your data or a monthly PDF report.',
  },
  csvSection: {
    title: 'Export CSV',
    availability: 'Available on Studio and Coletivo plans',
    planLockedAlert: 'Your current plan does not include CSV export. Upgrade.',
    leadsButton: 'Leads (CSV)',
    eventsButton: 'Events (CSV)',
    downloading: 'Downloading…',
  },
  pdfSection: {
    title: 'Monthly PDF report',
    availability: 'Available on the Coletivo plan',
    monthPlaceholder: 'Month',
    yearPlaceholder: 'Year',
    planLockedAlert: 'Your current plan does not include PDF reports.',
    downloadButton: 'Download PDF',
    generating: 'Generating PDF…',
  },
  months: {
    january: 'January',
    february: 'February',
    march: 'March',
    april: 'April',
    may: 'May',
    june: 'June',
    july: 'July',
    august: 'August',
    september: 'September',
    october: 'October',
    november: 'November',
    december: 'December',
  },
};

export default reportsTranslateEN;
